import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromResult from '../reducers/result.reducer';

export const getResultState = createSelector(
  fromFeature.getProductsState,
  (state: fromFeature.DashboardState) => state.result
);

export const getResult = createSelector(getResultState, fromResult.getResult);
export const getToken = createSelector(getResultState, fromResult.getToken);
export const getProjectsComments = createSelector(getResultState, fromResult.getProjectsComments);
export const getVersionComments = createSelector(getResultState, fromResult.getVersionComments);
export const getResultLoaded = createSelector(getResultState, fromResult.geResultLoaded);
